import { cn } from "@/zapi-frontend/shared/lib/utils";
import "./LiveUpdateShimmer.css";

// Laid over content whose analysis is being updated: the old content stays on screen and readable
// while a grey highlight sweeps across its text. Clicks, scrolling and selection reach the content.
export function LiveUpdateShimmer({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      data-testid="live-update-shimmer"
      className={cn("live-update-shimmer pointer-events-none", className)}
    />
  );
}
